export const font = {
    supreme: "Supreme, sans-serif"
}